var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.user && _vm.user.gallery)?_c('b-row',_vm._l((_vm.user.gallery),function(img){return _c('b-col',{key:img.id,attrs:{"md":"6","xl":"4"}},[_c('b-card',{staticClass:"gallery-image",attrs:{"img-src":_vm.imgUrl + img.urlmomentpicture,"overlay":"","text-variant":"white","img-alt":"card img","body-class":"bg-overlay"}})],1)}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }